export default {
  RISK_RECOMMENDATION_HEADER:
    "Based on your answer, we've determined your risk tolerance.",
  RISK_RECOMMENDATION_SUBHEADING_1:
    "Your risk tolerance represents the level of risk we will incorporate into your investment portfolio.",
  RISK_RECOMMENDATION_SUBHEADING_2:
    "Changing your risk tolerance here will change the portfolio's construction.",
  RADIO_ITEMS: [
    {
      label: "Conservative",
      subheading: "Lowest risk, lower reward potential",
      value: "Conservative",
    },
    {
      label: "Moderate",
      subheading: "Some risk, middling reward potential",
      value: "Moderate",
    },
    {
      label: "Aggressive",
      subheading: "Highest risk and reward potential",
      value: "Aggressive",
    },
  ],
  RISK_RECOMMENDATION_BUTTON_HEADING: "Next",
};
